import _toConsumableArray from "/github/workspace/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from 'react';
import { calcLoopedSlides } from '../shared/calc-looped-slides.js';
function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });
  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/React.cloneElement(child, {
      key: "".concat(child.key, "-duplicate-").concat(index, "-").concat(position),
      className: "".concat(child.props.className || '', " ").concat(swiperParams.slideDuplicateClass)
    });
  }
  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;
    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/React.createElement("div", {
          className: "".concat(swiperParams.slideClass, " ").concat(swiperParams.slideBlankClass)
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }
  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }
  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];
  for (var _i = 0; _i < loopedSlides; _i += 1) {
    var index = _i - Math.floor(_i / modifiedSlides.length) * modifiedSlides.length;
    appendSlides.push(duplicateSlide(modifiedSlides[index], _i, 'append'));
    prependSlides.unshift(duplicateSlide(modifiedSlides[modifiedSlides.length - index - 1], _i, 'prepend'));
  }
  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }
  return [].concat(prependSlides, _toConsumableArray(modifiedSlides), appendSlides);
}
export { calcLoopedSlides, renderLoop };